/**
 * 대표번호 형식 검증
 * - 0000-0000 형식 (예: 1588-8282)
 * - 00(0)-0000-0000 형식 (예: 02-123-4567, 031-1234-5678)
 */
const FOUR_BY_FOUR = /\d{4}-\d{4}/;
const GENERAL_PHONE = /\d{2,4}-\d{3,4}-\d{4}/;

const REPRESENTATIVE_TEL_REGEX = new RegExp(`^(?:${FOUR_BY_FOUR.source}|${GENERAL_PHONE.source})$`);

const validateRepresentativeTelFormat = (value: string) => REPRESENTATIVE_TEL_REGEX.test(value);

export default validateRepresentativeTelFormat;
